import { Link } from 'react-router-dom';
import { Camera, Globe, Music2, Mail, Phone, MapPin } from 'lucide-react';
import Logo from './Logo';

export default function Footer() {
  return (
    <footer className="relative mt-24 border-t border-white/10 bg-ink-900/60">
      <div className="section grid gap-10 py-14 md:grid-cols-4">
        <div className="space-y-4">
          <Logo />
          <p className="max-w-xs text-sm text-ink-300">
            Crafting unforgettable moments — premium event planning & package
            booking, end to end.
          </p>
          <div className="flex gap-3">
            {[
              { Icon: Camera, href: 'https://instagram.com' },
              { Icon: Globe, href: 'https://eventstory.in' },
              { Icon: Music2, href: 'https://youtube.com' },
            ].map(({ Icon, href }, i) => (
              <a
                key={i}
                href={href}
                target="_blank"
                rel="noreferrer"
                className="grid h-10 w-10 place-items-center rounded-full border border-white/10 text-ink-200 transition hover:border-white/40 hover:text-white"
              >
                <Icon size={18} />
              </a>
            ))}
          </div>
        </div>

        <div>
          <h4 className="mb-4 font-display text-sm font-semibold uppercase tracking-wider text-ink-200">
            Explore
          </h4>
          <ul className="space-y-2 text-sm text-ink-300">
            <li><Link to="/packages" className="hover:text-white">Packages</Link></li>
            <li><Link to="/customize" className="hover:text-white">Customize</Link></li>
            <li><Link to="/about" className="hover:text-white">About Us</Link></li>
            <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
            <li><Link to="/privacy" className="hover:text-white">Privacy Policy</Link></li>
            <li><Link to="/delete" className="hover:text-white">Delete My Data</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="mb-4 font-display text-sm font-semibold uppercase tracking-wider text-ink-200">
            Events
          </h4>
          <ul className="space-y-2 text-sm text-ink-300">
            <li>Weddings</li>
            <li>Birthdays</li>
            <li>Corporate</li>
            <li>Concerts</li>
          </ul>
        </div>

        <div>
          <h4 className="mb-4 font-display text-sm font-semibold uppercase tracking-wider text-ink-200">
            Get in touch
          </h4>
          <ul className="space-y-3 text-sm text-ink-300">
            <li className="flex items-center gap-2"><Phone size={16} /> +91 9444 150808</li>
            <li className="flex items-center gap-2"><Mail size={16} /> hello@eventstory4u.com</li>
            <li className="flex items-center gap-2"><MapPin size={16} /> Mumbai, India</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10 py-5 text-center text-xs text-ink-400">
        © {new Date().getFullYear()} Event Story. All rights reserved.
      </div>
    </footer>
  );
}
